import { makeStyles } from '@material-ui/core'

import { getFont } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 4,
    position: 'relative',
    border: `1px solid ${theme.palette.grey[100]}`
  },
  titleContainer: {
    height: 50,
    textAlign: 'center',
    fontWeight: 700,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleContainerAfterSetValue: {
    backgroundColor: theme.palette.grey[400]
  },
  valueContainer: {
    height: 50,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  currencySelectorContainer: {
    position: 'absolute',
    right: 0,
    top: 2
  },
  input: {
    border: 'none',
    outline: 'none',
    width: '100%',
    fontSize: 16,
    lineHeight: '46px',
    marginLeft: '4%',
    fontFamily: getFont(),
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary
  },
  inputCenter: {
    textAlign: 'center'
  },
  titleInput: {
    backgroundColor: 'transparent',
    width: '50%',
    border: 'none',
    outline: 'none',
    textAlign: 'center'
  },
  deleteIconContainer: {
    position: 'absolute',
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 8,
    right: 8
  },
  deleteIcon: {
    fontSize: 16
  },
  menu: {
    backgroundColor: 'yellow'
  },
  clearIcon: {
    fontSize: 17,
    visibility: 'hidden'
  },
  clearIconShow: {
    visibility: 'visible',
    cursor: 'pointer'
  },
  iconInfo: {
    width: '100%',
    display: 'flex',
    padding: '0px 13px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
